import m from "../../geodata/es2015/chileLow";
window.am4geodata_chileLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/chileLow.js
// module id = null
// module chunks = 